import React, { useState } from "react"
import AuthService from "../../../services/auth-service"
import RegisterService from "../../../services/register-service"
import Button from "../../atoms/button/button"
import GenericModal from "../generic-modal/generic-modal"
import StandardModal from "../standard-modal/standard-modal"
import "./state-user-modal.scss"

const StateUserModal = props => {
  var isBrowser = typeof window !== "undefined"
  var inputUser = isBrowser
    ? sessionStorage.getItem("currentUserValue") !== null
      ? sessionStorage.getItem("currentUserValue")
      : ""
    : ""

  const [inputMailValue, setInputMailValue] = useState(
    inputUser ? inputUser : ""
  )

  const [mailError, setMailError] = useState(false)
  const [mailEmptyError, setMailEmptyError] = useState(false)
  const [mailNotFound, setMailNotFound] = useState(false)
  const [mailActive, setMailActive] = useState(false)
  const [disabledBtn, setDisabledBtn] = useState(false)

  const mailRegex = /(?:[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])/

  const handleSubmit = () => {
    setMailError(false)
    setMailActive(false)
    if (inputMailValue === "") {
      setMailEmptyError(true)
    } else {
      setMailEmptyError(false)
      if (mailRegex.test(inputMailValue)) {
        setMailError(false)

        setDisabledBtn(true)
        const dataService = "?email=" + inputMailValue.toLowerCase()

        AuthService.stateUser(dataService).then(res => {
          if (res.status === 400) {
            setMailNotFound(true)
            setDisabledBtn(false)
          }
          if (res.status === 200) {
            setMailNotFound(false)
            setMailError(false)
            setDisabledBtn(false)
            var payload = {
              username: inputMailValue,
            }
            switch (res.data.estado) {
              case "TRANSITORIO":
                props.setModalActive(
                  <StandardModal
                    title="Esperando autorización de tus padres"
                    description="Aún estamos esperando por la autorización de tus padres. No olvides recordarles los pasos a seguir para que sigas disfrutando de los beneficios que tenemos para ti."
                    button_title={
                      res.data.medioVerificacion === "SMS"
                        ? "Reenviar SMS"
                        : "Reenviar correo"
                    }
                    click={() => {
                      RegisterService.parentResentConfirmation(
                        "?username=" + inputMailValue
                      ).then(res => {
                        if (res.status === 200) {
                          props.setModalActive(null)
                        }
                      })
                    }}
                  />
                )
                break
              case "PENDIENTE":
                props.setModalActive(
                  <StandardModal
                    title="Esperando autorización de tus padres"
                    description="Aún estamos esperando por la autorización de tus padres. No olvides recordarles los pasos que deben seguir para que puedas comenzar a disfrutar de NosotrasOnline."
                    button_title={
                      res.data.medioVerificacion === "SMS"
                        ? "Reenviar SMS"
                        : "Reenviar correo"
                    }
                    click={() => {
                      RegisterService.parentResentConfirmation(
                        "?username=" + inputMailValue
                      ).then(res => {
                        if (res.status === 200) {
                          props.setModalActive(null)
                        }
                      })
                    }}
                  />
                )
                break
              case "REGISTRADO":
                RegisterService.codeVerificationResend(payload).then(res => {
                  console.log(res.status)
                })
                if (res.data.medioVerificacion === "EMAIL") {
                  props.setModalActive(
                    <StandardModal
                      title="Activa tu usuario"
                      description="Te hemos enviado un correo de activación para que puedas acceder a tu cuenta. Ahora revisa el correo con el que te registraste."
                      button_title="Reenviar correo"
                      click={() => {
                        props.setModalActive(null)
                        RegisterService.codeVerificationResend(payload).then(
                          res => {
                            console.log(res.status)
                          }
                        )
                      }}
                    />
                  )
                  break
                } else {
                  props.setModalActive(
                    <StandardModal
                      title="Activa tu usuario"
                      description="Te hemos enviado un SMS al número de celular con el que te registraste para que puedas acceder a tu cuenta."
                      button_title="Reenviar SMS"
                      click={() => {
                        props.setModalActive(null)
                        RegisterService.codeVerificationResend(payload).then(
                          res => {
                            console.log(res.status)
                          }
                        )
                      }}
                    />
                  )
                  break
                }

              case "ACTIVO":
                setMailActive(true)
                break
              case "TEMPORAL":
                setMailError(true)
                break

              default:
                RegisterService.codeVerificationResend(payload).then(res => {
                  console.log(res.status)
                })
                props.setModalActive(
                  <StandardModal
                    title="Activa"
                    subtitle="TU USUARIO"
                    description="Te hemos enviado un correo de activación para que puedas acceder a tu cuenta. Ahora revisa el correo con el que te registraste."
                    button_title="Perfecto"
                    click={() => {
                      props.setModalActive(null)
                    }}
                  />
                )
                break
            }
            sessionStorage.removeItem("currentUserValue")
          }
        })
      } else {
        setMailError(true)
      }
    }
  }

  return (
    <GenericModal>
      <div className="f-modal-info">
        <div className="f-main-title-container">
          <h1 className="f-main-title">Estado de tu registro</h1>
        </div>
        <div className="f-description-container">
          <label className="f-description">
            Ingresa el correo con el que te registraste en NosotrasOnline para
            que podamos conocer el estado de tu registro.
          </label>
        </div>
        <div className="f-group-input">
          <label className="f-label-form f-label-email">
            CORREO ELECTRÓNICO
          </label>
          <input
            className={
              "f-input " + (mailError || mailEmptyError ? "f-error-input" : "")
            }
            name="f-input-state-email"
            type="text"
            value={inputMailValue}
            onChange={e => setInputMailValue(e.target.value)}
          />
          <p className="f-form-message">
            <span className="f-error-form">
              {mailEmptyError && " *Campo requerido"}
              {mailError && " *Correo inválido"}
              {mailNotFound &&
                " *Este correo no ha sido registrado, puedes crear una cuenta con él."}
            </span>
            <span className="f-success-form">
              {mailActive && " *Este usuario ya está activo."}
            </span>
          </p>
        </div>
        <div className="f-button-action-container" onClick={handleSubmit}>
          <Button className="new-primary-pink short" title="Consultar" />
          {disabledBtn && (
            <div
              className="f-btn-disabled-mask"
              onClick={e => e.stopPropagation()}
            />
          )}
        </div>
      </div>
      <span
        className="icon2-close f-close-icon"
        onClick={() => props.setModalActive(null)}
      />
    </GenericModal>
  )
}

export default StateUserModal
